<app-header></app-header>

<section class="inerpages-banner">
    <img src="{{imgurl}}{{orderOnlineBanner['picture']}}" class="w-100">
    <div class="fade-bg"></div>
    <div class="mask-content-v-center text-center">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="tbox-iner text-center animate" data-anim-type="zoomIn">
                  <div class="heading-iner">
                    <h2 *ngIf="showLang == 'en' "> {{orderOnlineBanner['smallCaption']}}</h2>
                    <h2 *ngIf="showLang == 'ar' "> {{orderOnlineBanner['smallCaption_ar']}}</h2>
                    
                    <hr>
                    <p *ngIf="showLang == 'en' "> {{orderOnlineBanner['bigCaption']}} </p>
                    <p *ngIf="showLang == 'ar' "> {{orderOnlineBanner['bigCaption_ar']}} </p>
                    
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>
</section>


<section class="order-online animate fadeInUp" data-anim-type="fadeInUp">
<div class="container-fluid">
<div class="row discover_products">
    <div class="heading_secs col-sm-5 col-md-3">
      <div class="row">
        <div class="col-md-12 heading">
          <h4>{{ 'product_list.menu' | translate }}</h4>
        </div>  
      </div>

      <div class="row">
        <div class="scroll-cate d-md-none">
  
          <div class="menu_box" *ngFor="let ct of cats">
     <div class="card h-100">
       <a [routerLink]="['/order-online/cats/', ct.cslug]" *ngIf="!ct.hasSubcat">
         <img class="img-fluid w-100" src="{{imgurl}}{{ct.cimage}}" alt="{{ct.cname}}">
         <div class="card-body align-items-center">
          <p *ngIf="showLang =='en' " class="card-text">{{ct.cname}}</p>
           <p *ngIf="showLang =='ar' " class="card-text">{{ct.cname_ar}}</p>
         </div>
       </a>
  
       <a [routerLink]="['/order-online/subcats/', ct.cslug]" *ngIf="ct.hasSubcat">
           <img class="img-fluid w-100" src="{{imgurl}}{{ct.cimage}}" alt="{{ct.cname}}">
           <div class="card-body align-items-center">
             <p *ngIf="showLang =='en' " class="card-text">{{ct.cname}}</p>
             <p *ngIf="showLang =='ar' " class="card-text">{{ct.cname_ar}}</p>
           </div>
       </a>
     </div>
  
     </div>
   </div>
      </div>
      
      <div class="row d-md-flex d-none">

               <div class="col-md-6 col-6 menu_box" *ngFor="let ct of cats">
          <div class="card h-100">
            <a [routerLink]="['/order-online/cats/', ct.cslug]" *ngIf="!ct.hasSubcat">
              <img class="img-fluid w-100" src="{{imgurl}}{{ct.cimage}}" alt="{{ct.cname}}">
              <div class="card-body align-items-center">
                <p *ngIf="showLang =='en' " class="card-text">{{ct.cname}}</p>
                <p *ngIf="showLang =='ar' " class="card-text">{{ct.cname_ar}}</p>
              </div>
            </a>

            <a [routerLink]="['/order-online/subcats/', ct.cslug]" *ngIf="ct.hasSubcat">
                <img class="img-fluid w-100" src="{{imgurl}}{{ct.cimage}}" alt="{{ct.cname}}">
                <div class="card-body align-items-center">
                  <p *ngIf="showLang =='en' " class="card-text">{{ct.cname}}</p>
                  <p *ngIf="showLang =='ar' " class="card-text">{{ct.cname_ar}}</p>
                </div>
            </a>
          </div>

          </div>
        </div>
          </div>

          <div class="products_secs col-sm-7 col-md-9">
          
              <div class="col-md-12 text-center my-4" *ngIf="isLoading"> 
                <span class="lodercont">
                  <app-refreshloader></app-refreshloader>
                </span>
              </div>
      
          <h2 *ngIf="showLang =='en' " class="main-heading">{{catName}}</h2>
          <h2 *ngIf="showLang =='ar' " class="main-heading">{{catNameAr}}</h2>
   
            <div class="col-lg-3 product_box subcat-list col-md-6 col-6 mb-1" *ngFor="let ct of subcatsAr">
              <div class="card h-100">
                <a [routerLink]="['/order-online/cats/', ct.cslug]">
                  <img class="img-fluid w-100" src="{{imgurl}}{{ct.cimage}}" alt="{{ct.cname}}">
                  <div class="card-body align-items-center">
                    <p *ngIf="showLang =='en' " class="card-text">{{ct.cname}}</p>
                    <p *ngIf="showLang =='ar' " class="card-text">{{ct.cname_ar}}</p>
                  </div>
                </a>
              </div>
         
            </div>

          </div>

         
        </div>
      </div>
    </section>